import { LDFlagSet } from "launchdarkly-js-sdk-common";
import { sendTealiumEvent } from "../helpers";
import { createGa4Event, Ga4Event } from "../helpers/analytics";
import { AppState } from "../@types";
import { HelpDrawerAnalytics } from "./HelpDrawerWrapper";

export const newBasicHelperDrawerAnalytics = ({
  clickText,
  state,
  flags,
}: {
  clickText: string;
  state: AppState;
  flags: LDFlagSet;
}): HelpDrawerAnalytics => {
  return {
    openDrawer: () => {
      sendTealiumEvent("Help drawer", "opened");
      createGa4Event({
        event_name: Ga4Event.HELP_DRAWER_OPENED,
        click_text: clickText,
        state: state,
        flags: flags,
      });
    },
    closeDrawer: () => {
      sendTealiumEvent("Help drawer", "closed");
      createGa4Event({
        event_name: Ga4Event.HELP_DRAWER_CLOSED,
        click_text: clickText,
        state: state,
        flags: flags,
      });
    },
  };
};
